<template>
  <div class="child_banner">

    <div class="dm cle">
      <div class="it fl" @click="gotoPrvePath">
        <img src="/static/img/p9.png" />
      </div>
      <div class="it fr" @click="gotoNextPath">
        <img src="/static/img/p10.png" />
      </div>

      <div class="back_home" @click="goHome">

        <img src="/static/img/p11.png" />
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "ChildBan",
    props: {
      index: {
        type: String,
        default: '0'
      },
      type:{
        type: String,
        default: '0'
      }
    },
    data() {
      return {
        dataPath: [{
          path: 'enterprise',
          int: 0,
          name: '公司介绍'
        }, {
          path: 'service',
          int: 1,
          name: '服务内容'
        }, {
          path: 'cases',
          int: 2,
          name: '服务案例'
        }, {
          path: 'servingCustomers',
          int: 3,
          name: '服务客户'
        }, {
          path: 'honor',
          int: 4,
          name: '企业荣誉'
        }, {
          path: 'recruit',
          int: 5,
          name: '企业招聘'
        }, {
          path: 'culture',
          int: 6,
          name: '企业文化'
        }, {
          path: 'administration',
          int: 7,
          name: '公司管理层'
        }, {
          path: 'course',
          int: 8,
          name: '企业历程'
        }, {
          path: 'contactus',
          int: 9,
          name: '联系我们'
        }],
        index_path: null,



      }
    },
    methods: {
      goHome() {
        this.$router.push({
          path: '/'
        })
      },
      gotoPrvePath() {
        var that = this;
        if (that.index_path.int == 0) {
          this.$router.push({
            path: '/'
          })
          return false
        } else {
          console.log(that.dataPath[that.index_path.int - 1]);
          this.$router.push({
            path: that.dataPath[that.index_path.int - 1].path
          })
        }
      },
      gotoNextPath() {
        var that = this;
        // this.$router.push({
        //   path: 'administration'
        // })
        console.log(that.index_path);

        if (that.index_path.int == 9) {
          that.$router.push({
            path: '/'
          })
          return false
        } else {
          console.log(that.dataPath[that.index_path.int + 1]);
          this.$router.push({
            path: that.dataPath[that.index_path.int + 1].path
          })
        }
      }
    },
    created() {
      console.log(this.index);
      var that = this;
      console.log(that.$routers.history.current.name);
      this.dataPath.forEach(function(item, index) {
        console.log(item.path);
        if (that.$routers.history.current.name == item.path) {
          that.index_path = item;
          console.log(that.index_path);
        }
      })
    },
  }
</script>

<style lang="less">
  .child_banner {
    position: fixed;
    z-index: 999;
    width: 100%;
    bottom: 35px;

    .dm {
      padding: 0px 50px;
      text-align: left;

      .it {
        width: 42px;
        height: 42px;
        background: #5F5F5F;
        border-radius: 50%;
        cursor: pointer;
      }

      .back_home {
        position: absolute;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background: #5F5F5F;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ChildBan.vue